<template>
  <div class="field-switch-input" :class="{ 'has-error': $validator.errors.has(name, validateScope) }">
    <div class="field-switch-input-inner">
      <el-radio v-model="internalSwitch" :name="name + '__switch'" label="0" style="font-size: 1rem;">
        {{inactiveLabel}}
      </el-radio>
      <template v-for="extraOption in extraOptions">
        <el-radio v-model="internalSwitch" :name="name + '__switch'" :label="extraOption.value"
                  style="font-size: 1rem;">{{extraOption.label}}
        </el-radio>
      </template>
      <div class="display: flex; flex-direction: row;">
        <el-radio v-model="internalSwitch" :name="name + '__switch'" label="1" style="font-size: 1rem;">
          {{activeLabel}}
        </el-radio>
        <el-input v-model="internalValue" :disabled="internalSwitch !== '1'" :placeholder="placeholder" :name="name"
                  v-validate="validate" data-vv-value-path="internalValue" :data-vv-as="validateLabel"></el-input>
      </div>
    </div>
    <span class="error-message"><strong>{{$validator.errors.first(name, validateScope)}}</strong></span>
  </div>
</template>

<script lang="js">
import CommonUtil from '../../../utils/common'
import FormatUtil from '../../../utils/format'

export default {
  name: 'FieldSwitchInputCmp',
  components: {},
  props: {
    value: null,
    name: '',
    placeholder: null,
    validate: null,
    validateLabel: '',
    validateScope: null,
    inactiveLabel: {type: String, default: '指定しない'},
    activeLabel: {type: String, default: '指定する'},
    extraOptions: {type: Array, default: () => []}
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data () {
    return {
      extraOptionValues: this.extraOptions.map(extraOption => extraOption.value),
      internalSwitch: '',
      internalValue: ''
    }
  },
  created () {
    this.internalSwitch = CommonUtil.isEmpty(this.value) ? '0' : this.extraOptionValues.indexOf(this.value) >= 0 ? this.value : '1'
    this.internalValue = this.internalSwitch === '1' ? FormatUtil.num2FracStr(this.value) : ''
  },
  watch: {
    internalSwitch (newValue) {
      this.internalValue = ''
      if (newValue !== '1') {
        if (this.extraOptionValues.indexOf(newValue) >= 0) {
          this.$nextTick(() => {
            this.$emit('input', newValue)
          })
          return
        }
      }
      this.$emit('input', this.internalValue)
    },
    value (newValue) {
      if (CommonUtil.isNotEmpty(newValue) && this.extraOptionValues.indexOf(newValue) < 0) {
        this.internalValue = newValue
      }
    },
    internalValue (newValue) {
      this.$emit('input', newValue)
    }
  }
}

</script>
<style scoped>
  .field-switch-input {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .field-switch-input-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }

  .field-switch-input-inner >>> .el-radio-group {
    flex-shrink: 0;
  }

  .field-switch-input-inner >>> .el-input {
    padding-left: 10px;
    width: 1px;
    flex-grow: 1;
    min-width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/switch-input.vue